import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IDataStore } from '@/services/dataStore/IDataStore'
import useDataStore from '@/services/dataStore/useDataStore'
import { BaseEffectSchema, IBaseEffect } from '@lifk/types'
import useSWRV from 'swrv'
import { z } from 'zod'

const useGetEffects = (includeDeprecated = false) => {
  const {
    dataStore,
    dataStoreSWRVKey,
    handleDataStoreError,
    disableValidations
  } = useDataStore()

  async function fetchEffects(dataStore: IDataStore): Promise<IBaseEffect[]> {
    try {
      const response = await dataStore.getEffects()

      const validation = z.array(BaseEffectSchema).safeParse(response)
      let effects: IBaseEffect[] = validation.data ?? []
      if (!validation.success) {
        effects = removeInvalidItems(
          response,
          validation.error,
          disableValidations.value
        )
      }

      return effects.filter((effect) => includeDeprecated || !effect.deprecated)
    } catch (e) {
      handleDataStoreError(e)
      return []
    }
  }

  const result = useSWRV(
    () =>
      `/effects/${dataStoreSWRVKey.value.perspective}?deprecated=${includeDeprecated}`,
    async () => {
      return await fetchEffects(dataStore.value)
    },
    {
      // 30s for adapters to prevent too many API calls to paid CMS's
      dedupingInterval: 30000
    }
  )

  return result
}

export { useGetEffects }
